import type { TimelineItem } from "../domain/timeline";

export const EDIT_WINDOW_MS = 24 * 3600 * 1000;

/**
 * Same rule as SQL log_call_outcome: only the call's rep logs it (an admin included: the RPC
 * refuses another rep's call), an unlogged call any time, a logged one within 24 h of its outcome.
 * A call still in progress (no outcome) belongs to the dialer. Timeline `at` = outcome_at when logged.
 */
export function canEditCallOutcome(
  item: Pick<TimelineItem, "sales_id" | "at" | "meta">,
  me: number | string | null | undefined,
  now: Date,
): boolean {
  if (me == null || item.sales_id == null) return false;
  if (String(item.sales_id) !== String(me)) return false;
  const outcome = item.meta.outcome;
  if (!outcome) return false;
  if (outcome === "unlogged") return true;
  return now.getTime() - Date.parse(item.at) <= EDIT_WINDOW_MS;
}
